import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import * as React from 'react';

import { Text } from '@/components/ui/text';
import { cn } from '@/lib/utils';

const RadioList = React.forwardRef<
    React.ElementRef<typeof RadioGroupPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
    return <RadioGroupPrimitive.Root className={cn('grid gap-2', className)} {...props} ref={ref} />;
});
RadioList.displayName = RadioGroupPrimitive.Root.displayName;

type RadioListItemProps = {
    label: string;
} & React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>;

const RadioListItem = React.forwardRef<React.ElementRef<typeof RadioGroupPrimitive.Item>, RadioListItemProps>(
    ({ className, label, ...props }, ref) => {
        const id = React.useId();

        return (
            <div className="flex items-center gap-2 rounded-sm hover:bg-cool-gray-25">
                <RadioGroupPrimitive.Item
                    ref={ref}
                    id={id}
                    className={cn(
                        'aspect-square h-4 w-4 rounded-full border border-neutral-300 shadow-sm focus:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
                        'data-[state=checked]:border-blue-400',
                        className,
                    )}
                    {...props}
                >
                    <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
                        <div className="h-2.5 w-2.5 rounded-full bg-blue-400" />
                    </RadioGroupPrimitive.Indicator>
                </RadioGroupPrimitive.Item>
                <label htmlFor={id} className="cursor-pointer">
                    <Text color={props.disabled ? 'neutral-300' : 'neutral-600'}>{label}</Text>
                </label>
            </div>
        );
    },
);
RadioListItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioList, RadioListItem };
